import { useRef } from 'react';
export var useTimer = function () {
    var startTimeRef = useRef(null);
    var isActive = function () { return Boolean(startTimeRef.current); };
    var start = function () {
        startTimeRef.current = new Date().getTime();
    };
    var stop = function () {
        if (startTimeRef.current) {
            var timeDiff = new Date().getTime() - startTimeRef.current;
            startTimeRef.current = null;
            return timeDiff;
        }
    };
    return [isActive, start, stop];
};
//# sourceMappingURL=use-timer.js.map